// @ts-nocheck: converted from JS

import Export from '@/components/Studies/Export';

export default Export;
